export default __webpack_public_path__ + "static/media/firefox-icon-color.45c2e620.svg";